// extracted by mini-css-extract-plugin
export default {"filters":"Table_filters__tj3t5","table-container":"Table_table-container__IPV0t"};